const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
const THRESHOLD = 1024;

export function humanFileSize(bytes: number, dp = 2) {
  if (Math.abs(bytes) < THRESHOLD) {
    return bytes + ' B';
  }

  let u = -1;
  const r = Math.pow(10, dp);

  do {
    bytes /= THRESHOLD;
    ++u;
  } while (Math.round(Math.abs(bytes) * r) / r >= THRESHOLD && u < units.length - 1);

  return bytes.toFixed(dp) + ' ' + units[u];
}
